
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,
    DxValidationRule
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';
 
 
import HabilidadService from '../services/habilidad-service';
import UsuarioHabilidadService from '../services/usuariohabilidad-service';




export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxEditing,
        DxLookup,
        DxForm,
        DxItem,
        DxFilterRow,
        DxSearchPanel,
        DxScrolling,
        DxPager,
        DxToast,
        DxValidationRule
    },
    props: {
    supplierId: {
      type: Number,
      default: null,
    },
  },
    data() {
        
        return {
            
            procedimientos: null,
            dataSourceUsuarios: null,
            dataSourceRoles: null,
             dataSourceHabilidades: null,
            allowedPageSizes: [5, 10, 20, 50, 'all'],
            showInfo: true,
            showNavButtons: true,
            isVisible: false,
            message: '',
            type: 'info',
            popupOptions: {
                title: 'Habilidades',
                showTitle: true,
                width: 400,
                height: 300,
            },
             
           
            
        };
    },
    created() {
        
         this.usuariohabilidadService = new UsuarioHabilidadService();
        this.habilidadService = new HabilidadService();

    },
    mounted() {
        
        this.loadDataInfo();
    },
    methods: {
        loadDataInfo() {
             
        
            //this.usuarioService.getUsuario().then(data => this.dataSourceUsuarios = data);
            let idusuario = this.supplierId;
            let myJSON = JSON.stringify({
                pusuarioid: idusuario
            });
            this.usuariohabilidadService.getUsuarioHabilidad(myJSON).then(data => this.dataSourceUsuarios = data);
            this.habilidadService.getHabilidad().then(data => this.dataSourceHabilidades = data);
        },
        onSaved() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        onEditCanceled() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        logEvent(eventName) {
            this.events.unshift(eventName);
        },
       
        deleteRegister(e) {
            console.log(e.data);
            let myJSON = JSON.stringify({
                pid: e.data.id,
            });


            this.usuariohabilidadService.deleteUsuarioHabilidad(myJSON).then(() => {
                this.type = 'success';
                this.message = 'Se ha eliminado el registro';
                this.isVisible = true;
                this.loadDataInfo();
            });

        },
        createRegister(e) {


            let idusuario =this.supplierId;
            let myJSON = JSON.stringify({
                pusuarioid: idusuario,
                phabilidadid: e.data.habilidadid,

            });


            this.usuariohabilidadService.createUsuarioHabilidad(myJSON).then(() => {
                this.type = 'success';
                this.message = 'Se ha creado el registro';
                this.isVisible = true;
                this.loadDataInfo();
            });

        },
        onInitNewRow(e) {
            e.data.bactivo = true;
        },
    },
};
